

import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, Button, IconButton, useTheme, Box, Autocomplete,FormControl,Select,MenuItem
} from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';


const MaterialWiseVendor = ({ vendors, setVendors }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [vendor, setVendor] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  

  useEffect(() => {
    if (!isDataLoaded) {
      const para = { p_companyid: 1 };
      callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setVendor(data);
            setIsDataLoaded(true);
          }
        })
        .catch(error => console.error('Error fetching designations:', error));
    }
  }, [isDataLoaded]);



  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedContacts = [...vendors];
    updatedContacts[index][name] = value;
    setVendors(updatedContacts);
  };

  const handleAutocompleteChange = (index, name, value) => {
    const updatedContacts = [...vendors];
    updatedContacts[index][name] = value;
    updatedContacts[index][`${name}Id`] = value?.id || '';
    setVendors(updatedContacts);
  };

  const addContact = () => {
    setVendors([...vendors, {     
      vendor: null,
      vendorId: '',   
    }]);
  };

  const removeContact = (index) => {
    const updatedContacts = vendors.filter((_, i) => i !== index);
    setVendors(updatedContacts);
  };

  return (
    <Box
    gridColumn="span 9"
        gridRow={"span 2"}
        alignItems="center"
        justifyContent="center"
        // padding={1}
        sx={{
          "& .MuiTable-root": { border: "none", size: "small" },
          "& .MuiTableCell-root": {
            borderBottom: "none",
            border: "1px solid",
            borderColor: `${colors.primary[400]} !important`,
          },
          "& .name-column--cell": { color: colors.greenAccent[300] },
          "& .MuiTableHead-root": { borderBottom: "none" },
          "& .MuiTableBody-root": { overflowY: "auto" },
          "& .MuiCheckbox-root": {
            color: `${colors.blueAccent[200]} !important`,
            size: "small",
          },
          "& .MuiTableFooter-root": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
            height: "10px",
          },
          "& .MuiButton-text": { color: `${colors.grey[100]} !important` },
        }}
    >
      <TableContainer >
        <Table size="small">
          <TableHead>
            <TableRow>           
             
                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Vendor</TableCell>
                 
                 <TableCell style={{ size: "small", border: '1px solid transparent', fontSize: '14px' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vendors.map((contact, index) => {
              const selectedVendor = vendor.find(d => d.id === contact.vendorId) || null;
             
              return (
                <TableRow key={index}>
                  
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <Autocomplete
                    size='small'
                      options={vendor}
                      getOptionLabel={(option) => option.companyname}
                      value={selectedVendor}
                      onChange={(event, newValue) => handleAutocompleteChange(index, 'vendor', newValue)}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      renderInput={(params) => <TextField size='small' {...params} fullWidth />}
                    />
                  </TableCell>
                 
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <IconButton onClick={() => removeContact(index)}>
                      <HighlightOffOutlinedIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell colSpan={9}>
                <Button
                sx={{textTransform:'none'}}
                  onClick={addContact}
                  variant="standard"
                  color="secondary"
                  startIcon={<AddIcon sx={{color:colors.blueAccent[500]}} />}
                >
                  Add Vendor
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MaterialWiseVendor;



